import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';

import CustomerSearchMini from './CustomerSearchMini';

import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';

import Tooltip from '@mui/material/Tooltip';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard, faUser } from "@fortawesome/pro-regular-svg-icons";

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

import CircularProgress from '@mui/material/CircularProgress';

import {getConfigValue} from './Config';

import {binarySearch} from './Utils';

//import trieSearch from 'trie-search';




const useStyles = makeStyles(theme => ({   
    
    searchBoxOuterRow: {
          display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
        width: '900px',
    },

    searchBoxDiv: {
      
        //backgroundColor: 'lightgray', //#F3F3F3',
    },
    contactDetailsRow: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',
   
        width:'100%',
        borderRadius: '3px',
        fontSize: '9pt',

    },
    searchParametersColumn: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'column',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',               
        //width:'100%',
        borderRadius: '3px',
        fontSize: '9pt',

    },
    customerSearchRow: {
        display: 'flex', 
        flexDirection: 'row', 
        justifyContent: 'flex-start',
        alignItems: 'flex-start',  
        flexWrap: 'wrap',
        marginLeft: '0.2em',
        // flexBasis: '100%',
        // height: '0',
    
       },
       textField : {
        width: '100px', 
        fontSize: '8pt',
        
      }, 
      customerSearchButton: {
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-end',   
        width: '100%',
       
      }, 
      contactDetailsColumn: {
        display: 'flex', 
        flexDirection: 'column',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',  
        padding: '.5em',
    },
    contactsInfoLine: {
        marginBottom: '1em',
        fontSize: '8pt',
    },
    customersList: {
        overflow: 'auto',
        maxHeight: 180,
        
        width: '300px',
        borderRadius: '3px',        
        
        
        
      },
    searchResultsDiv: {
        fontSize: '12pt',
        marginLeft:'1em',
        //backgroundColor: '#E3E3E3',
        // borderStyle: 'ridge',
        // borderWidth :'1px',
        // borderColor: 'lightGray',
        // borderRadius: '3px',
        // maxHeight: '175px',
    }
   
   

    }));

    


const CustomerSearch = (props) => {
    const classes = useStyles();
    var store = require('store')

     

    const [loadingButtons, setLoadingButtons] = useState({});

    const [searchObject, setSearchObject] = useState({});
   
    const [customers, setCustomers] = useState([]);
    
    const [selectedSearchResultAccount, setSelectedSearchResultAccount] = useState();

    const [doRefresh, setDoRefresh] = useState({});

    const [isLoadingCompanyNames, setIsLoadingCompanyNames] = useState(false);

   
    const [companyNames, setCompanyNames] = useState([]);

    const [popoverOpen, setPopoverOpen] = React.useState(false);

    const [matches, setMatches] = React.useState([]);

    const[searchForCustomersTrigger, setSearchForCustomersTrigger] = useState();

    const[searchTimerId, setSearchTimerId] = useState();

   

   
    const isLoading = (buttonName) => {
        return loadingButtons[buttonName];
    }

    const setLoading =(buttonName, isLoading) => {
        var ldnButtons = {...loadingButtons};
        ldnButtons[buttonName] = isLoading;
        setLoadingButtons(ldnButtons);        
    }

    const handleListItemClick = (account) => {
        setSelectedSearchResultAccount(account);

        showAccountDetails(account);

        props.onSelectCustomer(account);
    }

    const showAccountDetails = (account) => {
        var accountDetailsObject ={};
        accountDetailsObject.firstName = (account.FirstName ? account.FirstName : '');
        accountDetailsObject.lastName = (account.LastName ? account.LastName : '');    
        accountDetailsObject.address = (account.Address1 ?  account.Address1 : '');
        accountDetailsObject.areaCode = (account.ZipCode ? account.ZipCode : '');
        accountDetailsObject.area = (account.City ? account.City : '');
        accountDetailsObject.mobilePhone = (account.PhoneMobile ? account.PhoneMobile : '');
        accountDetailsObject.email = (account.Email ? account.Email : '');
        accountDetailsObject.organizationName = (account.OrganizationName ? account.OrganizationName : '');
        accountDetailsObject.organizationNo = (account.OrganizationNo ? account.OrganizationNo : '');

        setSearchObject(accountDetailsObject);
    }

    const onIdSearchObjectChange = (idSearchObject) => {
        console.log("search for customer by Id")
        //user has entered either customerNo, apiId or invoiceNo, clear the other search parameters
        setSearchObject(idSearchObject);
    }

 
    
    useEffect(() =>  { 
        if (searchForCustomersTrigger)
            searchForCustomers();
        
    },[searchForCustomersTrigger]) 
    

    const clearSearch = () => {
        var clearedSearchObject = {...searchObject};

        for (const [key, value] of Object.entries(clearedSearchObject)) {
            clearedSearchObject[key] = '';            
        }
        
        setSearchObject(clearedSearchObject);
        setDoRefresh(new Date()); //refresh child components
    }
    

    const searchForCustomers = async () => {        

        setLoading('searchForCustomers', true);
        setCustomers([]);

        const response = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/findCustomers/${store.get("sessionToken")}`, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.          
            headers: {
              'Content-Type': 'application/json'             
            },            
            body: JSON.stringify(searchObject) // body data type must match "Content-Type" header
        });

        const json = await response.json(); // parses JSON response into native JavaScript objects
              
        

        if (json["errorCode"]=='420'){        
            console.log("En feil oppstod, sammenkoblede konti kunne ikke hentes.");   
        }              
        else if (json["result"]=='success') {
            if (json.customers && Array.isArray(json.customers))
                setCustomers(json.customers);    
        }

        setLoading('searchForCustomers', false);
        
    }

    
    const onCompanySearch = (event) => {
        const phrase = event.target.value;
        setSearchObject({organizationName: phrase});  
        setPopoverOpen(true);
        
        if (searchTimerId)
            clearTimeout(searchTimerId);

        const timerId = setTimeout(() => {
            searchCompanyNamesX(phrase); 
        }, 300);

        setSearchTimerId(timerId);
        
        
    }

    const searchCompanyNamesX = async (phrase) => {     

        if (!phrase)
            setPopoverOpen(false);


        const res = await fetch(`${getConfigValue('serverBaseUrl')}/api/Admin/SearchCompanyName/${store.get("sessionToken")}/${phrase}`                              
        ).catch(e => {
         
        });

        if (res) {
            const json = await res.json();
            setMatches(json);                                   
        }
                
    };

    const onCompanyNameSelected = (companyName) => {
        setSearchObject({organizationName: companyName});
        setSearchForCustomersTrigger(Date.now());

    }

 

    return(        
        
        <div className={classes.searchBoxOuterRow}>

        <div className={classes.searchBoxDiv}>
                  
            <CustomerSearchMini doRefresh={doRefresh} searchForCustomers={searchForCustomers} onIdSearchObjectChange={onIdSearchObjectChange}/>

            <div className={classes.contactDetailsRow}>     
            
                                        
          
                {/* infoFields */}
                <div className={classes.contactDetailsColumn} >

                    <div className={classes.contactsInfoLine}>                                             
                  
                    <TextField InputLabelProps={{shrink: true}}  style={{width: '203px'}}
                        inputProps={{style: {fontSize: 12}}} style={{width: '203px'}}
                        onChange={onCompanySearch}
                        value= {searchObject.organizationName} className={classes.textField} 
                        variant="outlined" label="Firmanavn" size='small'
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onKeyDown={(ev)=>{if (ev.key==='Escape') setPopoverOpen(false);}}
                        onBlur={_=>setTimeout(()=>setPopoverOpen(false), 300)}
                   />
                    <div hidden={!popoverOpen} style={{ width: '300px',backgroundColor:'white', position: "absolute",zIndex: 9999 }}>
                        <List dense style={{maxHeight: 200, overflow: 'auto'}}>                       
                            {
                                matches.map(
                                    (item) => {
                                        return <ListItem disablePadding>
                                            <ListItemButton>
                                                <ListItemText  primary={item} 
                                                    onClick={_=>{onCompanyNameSelected(item);
                                                    setPopoverOpen(false);                                                    
                                                    }}
                                                />
                                            </ListItemButton>   
                                        </ListItem> 
                                    }

                                )

                            }                                                        
                        </List>
                    </div>
                       

                
                        
                    </div>

                    <div className={classes.contactsInfoLine}>
                        <TextField InputLabelProps={{shrink: true}} inputProps={{style: {fontSize: 12}}} style={{width: '100px'}}
                        onChange={e => setSearchObject({...searchObject, firstName: e.target.value })}
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        value= {searchObject.firstName} className={classes.textField} 
                        variant="outlined" label="Fornavn" size='small'></TextField>
                        &nbsp;
                        <TextField InputLabelProps={{shrink: true}} 
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onChange={e => setSearchObject({...searchObject, lastName: e.target.value })} inputProps={{style: {fontSize: 12}}} value={searchObject.lastName} className={classes.textField} variant="outlined" label="Etternavn" size='small'></TextField>
                    </div>

                    <div className={classes.contactsInfoLine}>
                        <TextField InputLabelProps={{shrink: true}} 
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onChange={e => setSearchObject({...searchObject, address1: e.target.value })} inputProps={{style: {fontSize: 12}}} style={{width: '203px'}} value={searchObject.address} className={classes.textField} variant="outlined" label="Adresse" size='small'></TextField>                   
                    </div>

                    <div className={classes.contactsInfoLine}>
                        <TextField InputLabelProps={{shrink: true}} 
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onChange={e => setSearchObject({...searchObject, zipCode: e.target.value })} inputProps={{style: {fontSize: 12}}} style={{width: '80px'}} value={searchObject.areaCode} className={classes.textField} variant="outlined" label="Postnr" size='small'></TextField>
                        &nbsp;
                        <TextField InputLabelProps={{shrink: true}} 
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onChange={e => setSearchObject({...searchObject, city: e.target.value })} inputProps={{style: {fontSize: 12}}} style={{width: '120px'}} value={searchObject.area} className={classes.textField} variant="outlined" label="Poststed" size='small'></TextField>
                    </div>
                </div>
                <div className={classes.contactDetailsColumn} >
                    <div className={classes.contactsInfoLine}>
                        <TextField InputLabelProps={{shrink: true}} inputProps={{style: {fontSize: 12}}} style={{width: '203px'}}
                            onChange={e => setSearchObject({...searchObject, organizationNo: e.target.value })}
                            onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                            value= {searchObject.organizationNo} className={classes.textField} 
                            variant="outlined" label="Organisasjonsummer" size='small'></TextField>
                    </div>
                    <div className={classes.contactsInfoLine}>
                        <TextField InputLabelProps={{shrink: true}} 
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onChange={e => setSearchObject({...searchObject, mobilePhone: e.target.value })} inputProps={{style: {fontSize: 12}}} style={{width: '200px'}} value={searchObject.mobilePhone} className={classes.textField} variant="outlined" label="Mobiltelefon" size='small'></TextField>                    
                    </div>
                    <div className={classes.contactsInfoLine}>
                        <TextField InputLabelProps={{shrink: true}} 
                        onKeyPress={(ev)=>{if (ev.key==='Enter') searchForCustomers();}}
                        onChange={e => setSearchObject({...searchObject, email: e.target.value })} inputProps={{style: {fontSize: 12}}} style={{width: '200px'}} value={searchObject.email} className={classes.textField} variant="outlined" label="Epost" size='small'></TextField>
                    </div>

                     {/* SeachButton */}
                    <div className={classes.customerSearchButton}>
                        <LoadingButton onClick={clearSearch} variant="contained" size='small' color="primary">Tøm</LoadingButton>  
                         &nbsp; &nbsp; 
                        <LoadingButton loading={isLoading('searchForCustomers')} onClick={searchForCustomers} variant="contained" size='small' color="primary">Søk</LoadingButton>  
                    </div>  

                </div>

                
      
            </div>


            
        </div>

        <div className={classes.searchResultsDiv}>
            { isLoading('searchForCustomers') && <CircularProgress /> }
            Søkeresultater ({customers.length})
            <List className={classes.customersList} dense={true}>
                {customers.map((item,index) => 
                    <ListItem selected={item ===selectedSearchResultAccount} onClick={() => handleListItemClick(item)}>
                        <ListItemIcon>
                            <FontAwesomeIcon icon={faIdCard} />
                        </ListItemIcon>
                        <ListItemText
                            primary={item.DisplayName}
                            secondary={item.CustomerId}
                        />
                    </ListItem>
                )}               
            </List>
            </div>

        </div>
    )
    
};

export default CustomerSearch;